import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_SUGGESTED_COMPETITORS_REQUEST } from "../actions/fetchSuggestedCompetitorActions";
import {
  fetchSuggestedCompetitorsSuccess,
  fetchSuggestedCompetitorsFailure,
} from "../actions/fetchSuggestedCompetitorActions";
import { fetchSuggestedCompetitors } from "../../../services/accIqService.js";

function* fetchSuggestedCompetitorsSaga(action) {
  try {
    const response = yield call(fetchSuggestedCompetitors, action.payload);

    yield put(fetchSuggestedCompetitorsSuccess(response));
  } catch (error) {
    yield put(
      fetchSuggestedCompetitorsFailure(error?.message || "Something went wrong")
    );
  }
}

export default function* fetchSuggestedCompetitorsWatcher() {
  yield takeLatest(
    FETCH_SUGGESTED_COMPETITORS_REQUEST,
    fetchSuggestedCompetitorsSaga
  );
}
